export default __webpack_public_path__ + "static/media/img.fde7acc9.jpg";